document.addEventListener('DOMContentLoaded', function () {
  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function updateTimers() {
    const timers = document.querySelectorAll('.gb-product-timer[data-launch-date]');

    timers.forEach(function (timer) {
      const launchDate = timer.getAttribute('data-launch-date');
      const timeElement = timer.querySelector('.gb-product-timer__time');

      if (!launchDate || !timeElement) return;

      const targetTime = new Date(launchDate).getTime();
      const now = new Date().getTime();
      const difference = targetTime - now;

      if (difference <= 0) {
        timeElement.textContent = 'JÁ DISPONÍVEL';
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / (1000 * 60)) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      timeElement.textContent =
        `${pad(days)}D ${pad(hours)}H ${pad(minutes)}M ${pad(seconds)}S`;
    });
  }

  updateTimers();
  setInterval(updateTimers, 1000);
});